export default "__VITE_ASSET__68cd443e__"